import React from 'react'
import Link from 'gatsby-link'

import logo from '../resources/logo@2x.png'
import logoIcon from '../resources/logo_simple.svg'

class Nav extends React.Component {
  render() {
    return (
      <nav className="page-nav container">
        <Link to={'/'} className="page-nav-brand" title="Bowl of Code">
          <img src={logoIcon} alt="Bowl of Code"/>
        </Link>

        <ul className="page-nav-navigation list-inline">
          <li>
            <Link to={'/'} data-hover="HOME/POSTS">HOME/POSTS</Link>
          </li>
        </ul>
      </nav>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js